import moment from "moment";

export interface HelenaType {
  readonly status: HelenaStatusEnum;
  readonly enabled: boolean;
  readonly sessionKey: HelenaSessionKeyType | null;
  readonly patientId: string | null;
  readonly patientStatus: HelenaPatientStatusEnum;
  readonly registrationLink: string | null;
}

export enum HelenaStatusEnum {
  UP,
  DOWN
}

export enum HelenaPatientStatusEnum {
  REGISTERED_WITH_ACCOUNT = "REGISTERED_WITH_ACCOUNT",
  REGISTERED_WITHOUT_ACCOUNT = "REGISTERED_WITHOUT_ACCOUNT",
  /**
   * @deprecated version 4.9
   */
  REGISTERED_ADULT = "REGISTERED_ADULT",
  /**
   * @deprecated version 4.9
   */
  REGISTERED_CHILD = "REGISTERED_CHILD",
  /**
   * @deprecated version 4.9
   */
  EXCLUSION = "EXCLUSION",
  NOT_REGISTERED = "NOT_REGISTERED",
  DELETED = "DELETED",
  BLOCKED_CAREGIVER = "BLOCKED_CAREGIVER"
}

export enum HelenaDocumentTypeEnum {
  ATTESTATION = "ATTESTATION"
}

export class Helena implements HelenaType {
  readonly status: HelenaStatusEnum;
  readonly enabled: boolean;
  readonly sessionKey: HelenaSessionKeyType | null;
  readonly patientId: string | null;
  readonly patientStatus: HelenaPatientStatusEnum;
  readonly registrationLink: string | null;

  constructor(
    status: HelenaStatusEnum,
    enabled: boolean,
    sessionKey: HelenaSessionKeyType | null,
    patientId: string | null,
    registrationLink: string | null,
    patientStatus: HelenaPatientStatusEnum
  ) {
    this.status = status;
    this.enabled = enabled;
    this.sessionKey = sessionKey;
    this.patientId = patientId;
    this.registrationLink = registrationLink;
    this.patientStatus = patientStatus;
  }
}

export class HelenaPrescription implements HelenaPrescriptionType {
  readonly prescriptionId: number;
  readonly pdf: string;

  constructor(data?: HelenaPrescriptionType) {
    this.prescriptionId = 0;
    this.pdf = "";
    data && Object.assign(this, data);
  }
}

export interface HelenaPrescriptionType {
  readonly prescriptionId: number;
  readonly pdf: string;
}

export interface HelenaSessionKeyType {
  readonly subjectToken: string;
  readonly subjectName: string;
  readonly nihii: string;
  readonly accessToken: string;
  readonly tokenType: string;
  readonly expiryDate?: Date;
  readonly jti: string;
  readonly scope: string;
}

export class HelenaSessionKey implements HelenaSessionKeyType {
  readonly subjectToken: string;
  readonly subjectName: string;
  readonly nihii: string;
  readonly accessToken: string;
  readonly tokenType: string;
  readonly expiryDate?: Date;
  readonly jti: string;
  readonly scope: string;

  constructor(data?: HelenaSessionKeyType | null) {
    this.subjectToken = "";
    this.subjectName = "";
    this.nihii = "";
    this.accessToken = "";
    this.tokenType = "";
    this.expiryDate = moment()
      .subtract("1", "day")
      .toDate();
    this.jti = "";
    this.scope = "";
    data && Object.assign(this, data);
  }
}

export interface HelenaDocumentType {
  readonly documentType: string;
  readonly title: string;
  readonly conclusion: string;
  readonly content: string;
}

export class HelenaDocument implements HelenaDocumentType {
  readonly documentType: string;
  readonly title: string;
  readonly conclusion: string;
  readonly content: string;

  constructor(data?: HelenaDocumentType) {
    this.documentType = "";
    this.title = "";
    this.conclusion = "";
    this.content = "";
    data && Object.assign(this, data);
  }
}
